import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { AxiosError } from "axios";

import { RootState } from "features/config/store";
import { DailyIncidentTableData } from "features/ms6/core/domain/DailyIncidentTableData.model";
import {
  DailyIncidentTableDataResponse,
  DailyIncidentTableDataRepository,
} from "features/ms6/data/ms6.repository";

export enum dailyIncidentTableDataState {
  initial,
  inProgress,
  success,
  fail,
}

interface InitialState {
  status: dailyIncidentTableDataState;
  message: string;
  data: DailyIncidentTableData | undefined;
}

const initialState: InitialState = {
  status: dailyIncidentTableDataState.initial,
  message: "",
  data: undefined,
};

export const dailyIncidentTableData = createAsyncThunk(
  "dailyIncidentTableData",
  async (_, { rejectWithValue }) => {
    try {
      const response: DailyIncidentTableDataResponse =
        await DailyIncidentTableDataRepository();
      return response.data;
    } catch (error) {
      if (error instanceof AxiosError) {
        if (!error.response) {
          throw error;
        }
        throw rejectWithValue(error.response.data.message);
      }
    }
  }
);

/* Main Slice */
export const dailyIncidentTableDataSlice = createSlice({
  name: "dailyIncidentTableData",
  initialState,
  reducers: {
    resetdailyIncidentTableData: (state) => {
      state.status = dailyIncidentTableDataState.initial;
      state.message = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(dailyIncidentTableData.pending, (state) => {
        state.status = dailyIncidentTableDataState.inProgress;
      })
      .addCase(dailyIncidentTableData.fulfilled, (state, action) => {
        if (action.payload) {
          const { message, data } = action.payload;
          state.status = dailyIncidentTableDataState.success;
          state.message = message;
          state.data = data;
        }
      })
      .addCase(dailyIncidentTableData.rejected, (state, action) => {
        state.status = dailyIncidentTableDataState.fail;
        state.message = action.payload as string;
      });
  },
});

export const selectdailyIncidentTableData = (state: RootState) =>
  state.dailyIncidentTableData;
export const { resetdailyIncidentTableData } =
  dailyIncidentTableDataSlice.actions;
export default dailyIncidentTableDataSlice.reducer;
